/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'book': {
    width: 16,
    height: 16,
    viewBox: '0 0 48 48',
    data: '<path pid="0" fill-rule="evenodd" clip-rule="evenodd" d="M45 3.1A2.1 2.1 0 0 0 42.9 1H10.35A7.37 7.37 0 0 0 3 8.32v31.36A7.3 7.3 0 0 0 10.35 47H42.9a2.1 2.1 0 0 0 2.1-2.1V3.1zm-36.88 3c.6-.59 1.4-.92 2.23-.92H40.8v27.18H10.35c-1.1 0-2.17.25-3.15.71V8.32c0-.83.33-1.63.92-2.22zM7.2 39.68a3.13 3.13 0 0 0 3.15 3.14H40.8v-6.27H10.35a3.16 3.16 0 0 0-3.15 3.13z"/>'
  }
})
